export const SCORE_CARD_SCHEMA = [
  {
    label: '渠道类-已授信',
    value: '1',
  },
  {
    label: '渠道类-新授信',
    value: '2',
  },
  {
    label: '直销类-非企业类已授信',
    value: '3',
  },
  {
    label: '直销类-非企业类新授信',
    value: '4',
  },
  {
    label: '直销类-企业类已授信',
    value: '5',
  },
  {
    label: '直销类-企业类新授信',
    value: '6',
  },
  {
    label: '小额授信类-已授信',
    value: '7',
  },
  {
    label: '代工类',
    value: '8',
  },
  {
    label: '小额授信类-新授信',
    value: '9',
  },
]
